import api from '../api/axios';

const BASE = process.env.REACT_APP_BASE_API_URL || process.env.REACT_APP_API_URL || '';
const withBase = (path: string) => `${BASE}${path}`;

export type UpscaleResponse = { message?: string } | any;

export const upscalePlan = async (planId: string, scale = 2) => {
  const res = await api.post(withBase(`/upscale/plan/${planId}`), { scale });
  return res.data as UpscaleResponse;
};

const upscaleService = {
  upscalePlan,
};

export default upscaleService;
